export const createFormDataFile = (file) =>
  new File([file], file.name, {
    type: file.type,
  });
